import { NavLink, Outlet } from "react-router-dom"
import { LayoutDashboard } from "lucide-react"
import clsx from "clsx"
import { Layout } from "@lilbillbiscuit/account-ui"
import { useMe } from "@/lib/auth"

const AUTH_BASE = "https://auth.lilbillbiscuit.com"

export function AppShell() {
  const me = useMe()
  const user = me.data?.user ?? null
  const isAdmin = me.data?.isAdmin ?? false
  const tagCount = me.data?.tags.length ?? 0
  // Build a login URL from the 401 response if available; fall back to the
  // account-ui default builder by leaving it undefined.
  const loginUrl = me.error?.loginUrl ?? null

  return (
    <Layout
      brand={{ title: "glarchive", subtitle: "Glee Club Archive", href: "/" }}
      authBase={AUTH_BASE}
      user={user}
      loginUrl={loginUrl}
      userSubtitle={user ? `${tagCount} tag${tagCount === 1 ? "" : "s"}` : undefined}
      nav={
        <>
          <NavLink to="/" end className={navCls}>Catalog</NavLink>
          {isAdmin && (
            <NavLink to="/admin" className={navCls}>
              <span className="inline-flex items-center gap-1.5">
                <LayoutDashboard size={14} /> Admin
              </span>
            </NavLink>
          )}
        </>
      }
    >
      <Outlet />
    </Layout>
  )
}

function navCls({ isActive }: { isActive: boolean }): string {
  return clsx(
    "rounded-lg px-3 py-1.5 text-th-fg/70 transition-colors hover:bg-th-glass/[0.06] hover:text-th-fg",
    isActive && "bg-th-glass/[0.08] text-th-fg"
  )
}
